import React, { FC, useEffect, useRef } from 'react';
import { Box } from '@src/atoms/Box';
import { Popover } from '@src/atoms/Popover';
import { classnames } from '@src/utils/classnames';
import { IMenuBaseProps } from './models';
import { Animation } from '@src/core/Animation';

import styles from './Menu.scss';

export const Menu: FC<IMenuBaseProps> = ({
  anchorEl,
  open,
  className,
  style,
  placement = 'bottom',
  children,
  offset,
  onClose,
}) => {
  const classes = classnames(styles.root, className);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cb = (e: MouseEvent) => {
      const isOutSideEvent = (e.target as HTMLElement).closest(`.${styles.root}`) !== ref.current;
      if (isOutSideEvent && open) {
        onClose();
      }
    };

    document.addEventListener('click', cb);

    return () => {
      document.removeEventListener('click', cb);
    };
  }, [onClose, open]);

  if (!anchorEl) return null;

  return (
    <Popover offset={offset} anchorEl={anchorEl} open={open} placement={placement}>
      <Animation open={open}>
        <Box ref={ref} className={classes} style={style} column>
          {children}
        </Box>
      </Animation>
    </Popover>
  );
};
